import React, { useEffect } from "react";
import "./Why_Choose.css";
import Common_Title from "../../common/common-title/Common_Title";
import { useDispatch, useSelector } from "react-redux";
import { GetAllwhychoose } from "../../../redux/aboutus";

const Why_Choose = ({ whychoose }) => {
  const staticImages = [
    "/assets/images/home/why_choose/img-1.png",
    "/assets/images/home/why_choose/img-2.png",
    "/assets/images/home/why_choose/img-3.png",
    "/assets/images/home/why_choose/img-4.png",
  ];

  return (
    <section className="Why_Choose">
      <div className="container">
        <div className="title_holder">
          <Common_Title
            title="Why Choose Our"
            subtitle="Career Guidance Platform"
          />
        </div>

        <div className="Why_Choose_content_div">
          <div className="row">
            <div className="col-lg-6">
              <p className="choose_text">
                A structured, data-driven approach combined with expert
                counselling to ensure informed and confident career decisions.
              </p>

              {whychoose?.length > 0
                ? whychoose?.map((item, index) => (
                    <div className="content_div_holder">
                      <div className="content_div">
                        <div>
                          <div className="content_icon_holder">
                            {/* <img
                            // src="/assets/images/home/why_choose/img-1.png"
                            src={process.env.REACT_APP_IMG_URL + item?.icon}
                            alt="icon"
                            className="content_icon"
                          /> */}
                            <img
                              src={staticImages[index]}
                              alt="icon"
                              className="content_icon"
                            />
                          </div>
                        </div>

                        <div className="content_text_div">
                          <p className="bold_text">
                            {/* Structured Assessment Approach */}
                            {item?.name}
                          </p>
                          <p className="normal_text">
                            {/* Scientifically designed aptitude, personality, & 
                            interest evaluations.  */}
                            {item?.subname}
                          </p>
                        </div>
                      </div>

                      {/* <div className="content_icon_holder">
                          <img
                            src="/assets/images/home/why_choose/img-1.png"
                            alt="icon"
                            className="content_icon"
                          />
                        </div>

                        <div className="content_text_div">
                          <p className="bold_text">
                            Structured Assessment Approach
                          </p>
                          <p className="normal_text">
                            Scientifically designed aptitude, personality, &
                            interest evaluations.
                            {/* {whychoose.subname} */}
                      {/* </p>
                        </div>
                      </div>

                      <div className="content_div">
                        <div className="content_icon_holder">
                          <img
                            src="/assets/images/home/why_choose/img-2.png"
                            alt="icon"
                            className="content_icon"
                          />
                        </div>

                        <div className="content_text_div">
                          <p className="bold_text">
                            Expert Counsellor Guidance
                          </p>
                          <p className="normal_text">
                            Professional one-to-one counselling with detailed
                            analysis and recommendations.
                          </p>
                        </div>
                      </div>

                      <div className="content_div">
                        <div className="content_icon_holder">
                          <img
                            src="/assets/images/home/why_choose/img-3.png"
                            alt="icon"
                            className="content_icon"
                          />
                        </div>

                        <div className="content_text_div">
                          <p className="bold_text">
                            Data-Driven Career Mapping
                          </p>
                          <p className="normal_text">
                            Clear stream, branch, course, & college insights
                            with eligibility guidance.
                          </p>
                        </div>
                      </div>

                      <div className="content_div">
                        <div className="content_icon_holder">
                          <img
                            src="/assets/images/home/why_choose/img-4.png"
                            alt="icon"
                            className="content_icon"
                          />
                        </div>

                        <div className="content_text_div">
                          <p className="bold_text">
                            Automated Detailed Reports
                          </p>
                          <p className="normal_text">
                            Comprehensive PDF reports with strengths,
                            weaknesses, and recommendations.
                          </p>
                        </div> */}
                    </div>
                  ))
                : "not Found"}
            </div>

            <div className="col-lg-5">
              <div className="col_right_div">
                <img
                  src="/assets/images/home/why_choose/Group-img.png"
                  alt="grp-img"
                  className="grp_img"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Why_Choose;
